import { Injectable } from '@angular/core';
import { findIana } from 'windows-iana';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  constructor() { }

  public getTimezoneName() {
    const today = new Date();
    const short = today.toLocaleDateString(undefined);
    const full = today.toLocaleDateString(undefined, { timeZoneName: 'long' });
    const shortIndex = full.indexOf(short);
    if (shortIndex >= 0) {
      const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
      const trimSet = new Set([' ', '\t', '\n', '\r', '\f', '\v', ',', '.', '-', ':', ';']); //Removing regex to trim the timezone and added some special characters to trim the timezone.
      let start = 0;
      let end = trimmed.length;
      while (start < end && trimSet.has(trimmed[start])) { start++; }
      while (end > start && trimSet.has(trimmed[end - 1])) { end--; }
      return trimmed.slice(start, end);
    } else {
      return full;
    }
  }

  public convertOrderDateTimeToLocalDateTime(collectedDate: Date, windowsTimeZone: string): Date {   
    const ianaTimeZones = findIana(windowsTimeZone);
    let collectedDateInLocalDateTime: Date = new Date(collectedDate);

    if (!ianaTimeZones || ianaTimeZones.length === 0) {
      console.error(`Time zone mapping for ${windowsTimeZone} not found`);
      return collectedDateInLocalDateTime;
    }

    // Take Local timezone & check that in the IANA timezones.
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const ianaTimeZone = ianaTimeZones.find(item => item === localTimeZone);
    if (ianaTimeZone) { // if exists
      console.debug('Order & Local Time zones are same');
      return collectedDateInLocalDateTime;
    }
    
    // Take the 1st item from ianaTimeZones, and convert the collectedDate to the local time zone.
    const fromTimeObject = moment.tz(collectedDate, ianaTimeZones[0]);
    const toTimeObject = fromTimeObject.tz(localTimeZone);
    collectedDateInLocalDateTime = toTimeObject.toDate();

    return collectedDateInLocalDateTime;
  }
}
